import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Fonts } from 'components/base-ui'
import StepItem from 'components/base-ui/StepItem'
import { Wrapper, QrCodeImage, StepsWrapper, ButtonText, ButtonIcon } from './styled'

interface InviteFriendsV2Props {
  qrCode: string
  onClickBack: VoidFunction
}

const InviteFriendsV2 = ({ qrCode, onClickBack }: InviteFriendsV2Props) => {
  const { t } = useTranslation()
  const shareCouponSteps = [
    {
      title: t('dineIn.shareCouponPage.steps.step2.title'),
      descirption: t('dineIn.shareCouponPage.steps.step2.description'),
    },
    {
      title: t('dineIn.shareCouponPage.steps.step3.title'),
      descirption: t('dineIn.shareCouponPage.steps.step3.description'),
    },
  ]

  return (
    <Wrapper>
      <QrCodeImage src={qrCode} />
      <Fonts.H4>{t('dineIn.invitePage.combineCoupon')}</Fonts.H4>
      <StepsWrapper>
        {shareCouponSteps.map(({ title, descirption }, index) => (
          <StepItem stepNumber={index + 1} title={title} description={descirption} />
        ))}
      </StepsWrapper>
      <Button onClick={onClickBack} md outline float style={{ alignSelf: 'end' }}>
        <ButtonIcon name="arrow-left" size="16px" />
        <ButtonText>{t('dineIn.invitePage.back')}</ButtonText>
      </Button>
    </Wrapper>
  )
}

export default InviteFriendsV2
